query LookupTrainingSearch(
  $orderBy: [TrainingFilesOrderBy!]
  $lookupName: String!
) {
  lookupTrainingSearch(orderBy: $orderBy, lookupName: $lookupName) {
    nodes {
      id
      name
      hint
      iconType
      sharedDocumentFile {
        _downloadLink
      }
    }
  }
}
